const getDateFromTimestamp= (timestamp) =>
  timestamp.slice(0, timestamp.indexOf("T"));

export default getDateFromTimestamp;
